<script setup>
import { ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    { title: 166, value: 166 },
    { title: 139, value: 139 },
    { title: 5000, value: 5000 },
    { title: 6000, value: 6000 },
    { title: 5555.555556, value: 5555.555556 },
    { title: 366.1638, value: 366.1638 },
    { title: 2721.56, value: 2721.56 },
    { title: 5714.28, value: 5714.28 }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('Dimensional Factor')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
